export function scrollToElement(element, behavior = 'smooth', offset = 0) {
  let top = element.getBoundingClientRect().top;
  top -= document.body.getBoundingClientRect().top;
  top -= offset;
  window.scrollTo({ behavior, top });
}

export const rescue = (fn, fallback = null) => {
  try {
    return fn();
  } catch (e) {
    if (typeof fallback === 'function') {
      return fallback(e);
    }
    return fallback;
  }
};
